interface LoginPromptModalProps {
  show: boolean;
  onClose: () => void;
  onStartIntro: () => void;
}

// 빈티지 스타일 상수
const VINTAGE_COLORS = {
  paper: "linear-gradient(135deg, #faf8f0 0%, #f5f0e1 100%)",
  border: "#d4c9b0",
  text: "#2a2a2a",
  textSecondary: "#666655",
  accent: "#8b7355",
  accentHover: "#7a6244",
  overlay: "rgba(0, 0, 0, 0.6)",
};

/**
 * 게스트 로그인 유도 모달 - 빈티지 스타일
 */
export function LoginPromptModal({
  show,
  onClose,
  onStartIntro,
}: LoginPromptModalProps) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ background: VINTAGE_COLORS.overlay, zIndex: 100000 }}
      onClick={onClose}
    >
      <div
        className="max-w-md w-full mx-4 p-8"
        style={{
          background: VINTAGE_COLORS.paper,
          border: `1px solid ${VINTAGE_COLORS.border}`,
          borderRadius: "12px",
          boxShadow: `
            0 20px 60px rgba(0, 0, 0, 0.3),
            inset 0 0 40px rgba(255, 255, 255, 0.5)
          `,
          fontFamily: "'Pretendard GOV Variable', 'Pretendard', sans-serif",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div
            className="text-4xl mb-4"
            style={{ filter: "drop-shadow(0 2px 4px rgba(139, 115, 85, 0.3))" }}
          >
            🏗️
          </div>
          <h2
            className="mb-3 text-xl font-bold"
            style={{
              color: VINTAGE_COLORS.text,
              fontFamily: "'Noto Serif KR', 'Georgia', serif",
            }}
          >
            건물을 세우시려면 등록이 필요해요
          </h2>
          <p
            className="mb-6 text-sm leading-relaxed"
            style={{ color: VINTAGE_COLORS.textSecondary }}
          >
            도시 안내원에게 등록하시면 나만의 건물을 세울 수 있어요.
            <br />
            무료랍니다!
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => {
                onClose();
                onStartIntro();
              }}
              className="flex-1 py-3 px-4 transition-all duration-300 font-medium hover:scale-[1.02] active:scale-[0.98]"
              style={{
                background: VINTAGE_COLORS.accent,
                border: "none",
                borderRadius: "8px",
                color: "#fff",
                boxShadow: "0 2px 8px rgba(139, 115, 85, 0.3)",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = VINTAGE_COLORS.accentHover)
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = VINTAGE_COLORS.accent)
              }
            >
              등록하러 가기
            </button>
            <button
              onClick={onClose}
              className="flex-1 py-3 px-4 transition-all duration-300 font-medium hover:bg-black/5"
              style={{
                background: "transparent",
                border: `1px solid ${VINTAGE_COLORS.border}`,
                borderRadius: "8px",
                color: VINTAGE_COLORS.textSecondary,
              }}
            >
              나중에 할게요
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
